import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { JBButton, JBFooter, JBIcon } from '@juliusbaer-gcrm/gcrm-frontend-components';

const SubmissionFooter = (props: {
  onClick: any;
  onClickCapture: () => void;
  disabled: boolean;
  onSubmitClick: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <JBFooter
      splitLayout
      leftButton={
        <JBButton
          onClick={props.onClick}
          onClickCapture={props.onClickCapture}
          id="contactnotefor-cancel-button"
          size="small"
          variant="outlined"
        >
          {t('noteform.footer.cancel', 'Cancel')}
        </JBButton>
      }
      additionalRightButton={
        <LoadingButton
          loading={props.disabled}
          disabled={props.disabled}
          type="submit"
          variant="outlined"
          id="contactnoteform-draft-button"
          size="small"
        >
          <Box mr={1} mt={0.5}>
            <JBIcon iconName="save" size="sm" />
          </Box>
          {t('noteform.footer.saveAsDraft', 'Save as draft')}
        </LoadingButton>
      }
      rightButton={
        <LoadingButton
          loading={props.disabled}
          disabled={props.disabled}
          type="submit"
          color="primary"
          variant="contained"
          id="contactnoteform-submit-button"
          onClick={props.onSubmitClick}
          size="small"
        >
          {t('noteform.footer.submit', 'Submit')}
        </LoadingButton>
      }
    />
  );
};

export default SubmissionFooter;
